import { render, staticRenderFns } from "./dialog-forward-contact-request.vue?vue&type=template&id=64ebfbff&scoped=true&"
import script from "./dialog-forward-contact-request.vue?vue&type=script&lang=js&"
export * from "./dialog-forward-contact-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ebfbff",
  null
  
)

export default component.exports